// app/javascript/controllers/tabs_controller.js
import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="tabs"
//
export default class extends Controller {
  static classes = ["active"];
  static targets = ["btn", "tab", "content"];
  static values = { defaultTab: String };

  connect() {
    this.showContent(0);
  }

  click(event) {
    // If the click is on a button inside a tab, find its parent tab
    const clickedElement = event.currentTarget;
    let tabElement;

    // If the clicked element is not a tab itself, find the parent tab
    if (!this.tabTargets.includes(clickedElement)) {
      tabElement = clickedElement.closest('[data-tabs-target="tab"]');
    } else {
      tabElement = clickedElement;
    }

    if (tabElement) {
      const index = this.tabTargets.indexOf(tabElement);
      this.showContent(index);
    }
  }

  showContent(index) {
    this.tabTargets.forEach((tab, i) => {
      tab.classList.toggle(this.activeClass || "active", i === index);
    });
    this.contentTargets.forEach((content, i) => {
      content.classList.toggle("hidden", i !== index);
    });
  }
}
